import { render, staticRenderFns } from "./unit-manager.vue?vue&type=template&id=b71bbcf2"
import script from "./unit-manager.vue?vue&type=script&lang=js"
export * from "./unit-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports